import React, { FC } from 'react';
import { VisibilityTracker } from 'dibs-visibility-tracker/exports/VisibilityTracker';

import { trackSalePdpInteraction } from './pdpSharedAuctionBannerTracking';

const PdpSharedAuctionBanner = React.lazy(
    () => import(/* webpackChunkName: "PdpSharedAuctionBannerLazy" */ './PdpSharedAuctionBanner')
);

const OFFSET_VERTICAL = 300;

export const PdpSharedAuctionBannerLazy: FC = () => {
    return (
        <VisibilityTracker
            observerOptions={{
                rootMargin: `${OFFSET_VERTICAL}px 0px ${OFFSET_VERTICAL}px 0px`,
            }}
            onVisibilityChange={({ isVisible }) => {
                if (isVisible) {
                    trackSalePdpInteraction({ action: 'browse Auctions displayed' });
                }
            }}
        >
            <React.Suspense fallback="">
                <PdpSharedAuctionBanner />
            </React.Suspense>
        </VisibilityTracker>
    );
};
